import {Component, Input, OnInit, ViewChild} from '@angular/core';
import * as QRCode from 'qrious';

@Component({
    selector: 'pz-qr-code',
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.styl']
})
export class QrCodeComponent implements OnInit {
    @Input() set content(content: string | number) {
        this.createQrcode(content);
    }

    @ViewChild('qr', {static: true}) public ele;

    public constructor() {
        //
    }

    public ngOnInit() {
    }

    public createQrcode(content) {
        const qr = new QRCode({
            element: this.ele.nativeElement,
            value: `${content}`
        });
        // äºç»´ç çè¯¯å·®æ ¡æ­£çº§å«(L, M, Q, H)
        qr.level = 'M';
        qr.size = 70;
    }
}
